// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"InboxPage-module__loginContainer___21Lpq"};